import { useEffect, useState } from "react";
import api from "@/lib/api";

const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString("en-AU", { day: "numeric", month: "short", year: "numeric" }) : "—");

export default function AcquisitionHistorySection({ partnerId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    if (!partnerId) return;
    api.get(`/admin/partners/${partnerId}/acquisition`)
      .then(({ data: d }) => { setData(d); setError(false); })
      .catch(() => { setData({}); setError(true); });
  }, [partnerId]);
  if (!data) return null;
  if (error) return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 mt-4" data-testid="acquisition-history-section">
      <h3 className="text-sm font-bold text-slate-700">Acquisition History</h3>
      <p className="mt-2 text-sm text-rose-600" data-testid="acquisition-load-error">Couldn't load acquisition history for this partner.</p>
    </div>
  );
  const acq = data.acquisition;
  const pr = data.prospect;
  const steps = acq ? [
    [pr?.created_at, `Prospect created (${pr?.source || acq.acquisition_source || "prospect"})`],
    [acq.first_invited_at, `Invitation sent${acq.campaign_id ? ` — campaign ${acq.campaign_id}` : ""}`],
    [acq.application_submitted_at, "Application submitted"],
    [acq.partner_activated_at, "Approved — Partner activated"],
  ].filter(([at]) => at) : [];
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 mt-4" data-testid="acquisition-history-section">
      <h3 className="text-sm font-bold text-slate-700">Acquisition History</h3>
      {!acq ? (
        <p className="mt-2 text-sm text-slate-500" data-testid="acquisition-organic">Organic / Direct Application — no prospect campaign attribution recorded.</p>
      ) : (
        <div className="mt-3 space-y-1.5">
          {steps.map(([at, label], i) => (
            <div key={i} className="flex items-start gap-3 text-sm" data-testid={`acq-step-${i}`}>
              <span className="w-28 shrink-0 text-slate-500 tabular-nums">{fmt(at)}</span>
              <span className="text-slate-800">{label}</span>
            </div>
          ))}
          <div className="mt-2 flex flex-wrap gap-3 text-xs text-slate-500">
            {acq.prospect_id && <a className="text-cyan-700 underline" href="/admin/partner-prospects" data-testid="acq-prospect-link">Prospect: {acq.prospect_id}</a>}
            {acq.campaign_id && <span>Campaign: {acq.campaign_id}</span>}
            {acq.application_id && <span>Application: {acq.application_id}</span>}
            <span>Source: {acq.acquisition_source}</span>
          </div>
        </div>
      )}
    </div>
  );
}
